import { NeoModel } from "@singularsystems/neo-core";
import BaseCheckQueryCommand from "./BaseCheckQueryCommand";

@NeoModel
export default class UpdateCheckQueryCommand extends BaseCheckQueryCommand {
    public checkQueryId: number = 0;
}